export const messages = {
  en: {
    outOrderManage: {
      queryConditions: 'Query Conditions',
      outOrderInfo: 'Outbound Order Information',
      orderId: 'Order ID',
      product: 'Product',
      applicant: 'Applicant',
      createTime: 'Create Time',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      outbound: 'Outbound',
      detail: 'Detail',
      search: 'Search',
      reset: 'Reset',
      pleaseInputApplicant: 'Please input applicant name',
      pleaseInputOrderId: 'Please input order ID',
      pleaseSelectStatus: 'Please select status'
    }
  },
  zh: {
    outOrderManage: {
      queryConditions: '查询条件',
      outOrderInfo: '出库单信息',
      orderId: '订单ID',
      product: '商品',
      applicant: '申请人',
      createTime: '创建时间',
      remark: '备注',
      status: '状态',
      operation: '操作',
      outbound: '出库',
      detail: '详情',
      search: '查询',
      reset: '重置',
      pleaseInputApplicant: '请输入申请人名称',
      pleaseInputOrderId: '请输入单号',
      pleaseSelectStatus: '请选择状态'
    }
  }
}